import CookieConsentServiceInstance from '@services/CookieConsentService';
import { CookieCategory } from '@shared-types/optanon.types';
import GtmHelper from '@tracking/gtm-helper';
import { getCookie, setCookie } from '@utilities/cookies';

export type PkBottomPanelOptions = {
  defaultCompleted?: number;
  openingTime?: number;
  cookieTag?: string;
  trackingEventLabel?: string;
};

const defaults: PkBottomPanelOptions = {
  defaultCompleted: 4,
  openingTime: 500,
  cookieTag: 'generic-sticky-panel',
  trackingEventLabel: 'promo-panel',
};

export default class PkBottomPanelPlugin {
  options: PkBottomPanelOptions;
  dom: HTMLPkBottomPanelElement;

  constructor(e: HTMLPkBottomPanelElement, o: PkBottomPanelOptions) {
    this.dom = e;
    this.options = { ...defaults, ...o };
  }

  init() {
    this.loadContent();
    this.dom.addEventListener('pkOpen', this.onOpen);
    this.dom.addEventListener('pkClose', this.onClose);
    this.dom.addEventListener('pkClick', (e: any) => {
      if (e.target?.classList.contains('download-app')) {
        GtmHelper.ga4Event('panel_dialog_main_action', { section_reference: this.options.trackingEventLabel });
      } else if (e.target?.classList.contains('no-download-app')) {
        GtmHelper.ga4Event('panel_dialog_secondary_action', { section_reference: this.options.trackingEventLabel });
        this.dom.close();
      } else {
        GtmHelper.ga4Event('panel_dialog_skip', { section_reference: this.options.trackingEventLabel });
      }
    });
  }

  checkCookies = (cookieTag: string) => {
    return getCookie(cookieTag);
  };

  loadContent = () => {
    if (this.checkCookies(this.options.cookieTag)) return;

    CookieConsentServiceInstance.waitForCookiesAccepted(CookieCategory.PERFORMANCE).then(() => {
      setTimeout(() => {
        this.dom.open();
      }, this.options.openingTime ?? 0);
    });
  };

  onOpen = () => {
    GtmHelper.ga4Event('panel_dialog_loaded', { section_reference: this.options.trackingEventLabel });
  };

  onClose = () => {
    if (this.options.cookieTag) {
      CookieConsentServiceInstance.waitForCookiesAccepted(CookieCategory.PERFORMANCE).then(() => {
        setCookie(this.options.cookieTag, true, {
          path: '/',
          domain: location.hostname === 'localhost' ? 'localhost' : '.uefa.com',
          expires: this.options.defaultCompleted,
        });
      });
    }
  };
}
